import {RequestHeaders, Spirs} from '../models/api/codegen/code';

const SpirsApi = new Spirs();

export function changeHeaderPlayer(player?: string, token?: string | null) {
    const header: RequestHeaders = {
        "Accept-Language": "ru"
    };
    if (player) {
        header['player'] = player;
        //token будет GUEST если участник не может совершать шаги, иначе токен не будет добавлятся в хедер
        if (player !== 'GUEST' && token === 'GUEST') {
            header['token'] = token;
        }
    }
    SpirsApi.setRequestHeadersHandler((headers) => ({...headers, ...header}))
}

export function getPlayerIdFromHeader() {
    return SpirsApi.getPlayerIdFromHeader();
}

export function changeDomain(domain: string) {
    SpirsApi.setDomain(domain);
}

//Coupons
export type postCouponParameters = Parameters<typeof SpirsApi.saveCouponUsingPOST>[0];

export function postCoupon(parameters: postCouponParameters) {
    return SpirsApi.saveCouponUsingPOST(parameters).then(r => r.body);
}

//Update Coupons
export type updateCouponParameters = Parameters<typeof SpirsApi.updateCouponUsingPOST>[0];

export function updateCoupons(parameters: updateCouponParameters) {
    return SpirsApi.updateCouponUsingPOST(parameters).then(r => r.body);
}

//Steps
export type getStepsParameters = Parameters<typeof SpirsApi.getStepsUsingGET>[0];

export function getSteps(parameters: getStepsParameters) {
    return SpirsApi.getStepsUsingGET(parameters).then(r => r.body);
}

export type getNotCalculatedStepsParameters = Parameters<typeof SpirsApi.getNotCalculatedStepsUsingGET>[0];
export function getNotCalculatedSteps(params: getNotCalculatedStepsParameters) {
    return SpirsApi.getNotCalculatedStepsUsingGET(params).then(r => r.body);
}

//One specific Fixture
export type getOneFixtureParameters = Parameters<typeof SpirsApi.getFixtureUsingGET>[0];

export function getFixture(parameters: getOneFixtureParameters) {
    return SpirsApi.getFixtureUsingGET(parameters).then(r => r.body);
}

//Sports
export type getSportsParameters = Parameters<typeof SpirsApi.getSportListUsingGET>[0];

export function getSports(parameters: getSportsParameters) {
    return SpirsApi.getSportListUsingGET(parameters).then(r => r.body);
}

//Categories
export type getCategoriesParameters = Parameters<typeof SpirsApi.getCategoryListUsingGET>[0];

export function getCategories(parameters: getCategoriesParameters) {
    return SpirsApi.getCategoryListUsingGET(parameters).then(r => r.body);
}

//Tournaments
export type getTournamentsParameters = Parameters<typeof SpirsApi.getTournamentListUsingGET>[0];

export function getTournaments(parameters: getTournamentsParameters) {
    return SpirsApi.getTournamentListUsingGET(parameters).then(r => r.body);
}

//Banner host port
export type getBannerHostPortParameters = Parameters<typeof SpirsApi.getBannerHostPortUsingGET>[0];

export function getBannerHostPort(parameters: getBannerHostPortParameters) {
    return SpirsApi.getBannerHostPortUsingGET(parameters).then(r => r.body);
}

//PlayerInfo
export type getPlayerInfoParameters = Parameters<typeof SpirsApi.getPlayerInfoUsingGET>[0];

export function getPlayerInfo(parameters: getPlayerInfoParameters) {
    return SpirsApi.getPlayerInfoUsingGET(parameters).then(r => r.body);
}

//PlayerSettings
export type getPlayerSettingsParameters = Parameters<typeof SpirsApi.getSettingsUsingGET>[0];

export function getPlayerSettings(parameters: getPlayerSettingsParameters) {
    return SpirsApi.getSettingsUsingGET(parameters).then(r => r.body);
}

export type savePlayerSettingsParameters = Parameters<typeof SpirsApi.saveSettingsUsingPOST>[0]

export function savePlayerSettings(parameters: savePlayerSettingsParameters) {
    return SpirsApi.saveSettingsUsingPOST(parameters).then(r => r.body);
}

// add favorite
export type getAddFavoriteParameters = Parameters<typeof SpirsApi.addUsingPOST>[0];

export function addFavorite(parameters: getAddFavoriteParameters) {
    return SpirsApi.addUsingPOST(parameters).then(r => r.body);
}

export function deleteFavorite(parameters: getAddFavoriteParameters) {
    return SpirsApi.deleteUsingPOST(parameters).then(r => r.body);
}

export function deleteOldFavourite(parameters: deleteOldFavourite) {
    return SpirsApi.deleteOldFavouritePOST(parameters).then(r => r.body);
}

//get rules
export type getRules = Parameters<typeof SpirsApi.ruleUsingGET>[0];

export type deleteOldFavourite = Parameters<typeof SpirsApi.deleteOldFavouritePOST>[0];

export function getRules(parameters: getRules) {
    return SpirsApi.ruleUsingGET(parameters).then(r => r.body);
}

//get chessLiveSportId
export type getChessLiveSportId = Parameters<typeof SpirsApi.chessLiveSportIdUsingGET>[0];

export function getChessLiveSportId(parameters: getChessLiveSportId) {
    return SpirsApi.chessLiveSportIdUsingGET(parameters).then(r => r.body);
}

export type toggleBalanceVisibility = Parameters<typeof SpirsApi.toggleBalanceVisibilityPOST>[0];
export const toggleBalanceVisibility = (parameters: toggleBalanceVisibility) => SpirsApi.toggleBalanceVisibilityPOST(parameters).then(r => r.body);
export type sendFingerprint = Parameters<typeof SpirsApi.sendFingerprintPOST>[0];

export const sendFingerprint = (parameter: sendFingerprint) => SpirsApi.sendFingerprintPOST(parameter).then(r => r.body);

export const getFavoritesTree = () => SpirsApi.getFavoritesTree().then(r => r.body);

export const getFavoritesCount = () => SpirsApi.getFavoritesCount().then(r => r.body);

export type getTreeFilter = Parameters<typeof SpirsApi.getTreeFilter>[0]
export const getTreeFilter = (p: getTreeFilter) => SpirsApi.getTreeFilter(p).then(r => r.body);

export const getSearchResult = (p: Parameters<typeof SpirsApi.getSearchResult>[0]) => SpirsApi.getSearchResult(p).then(r => r.body);

export type getTreeResult = Parameters<typeof SpirsApi.getTreeResult>[0];
export const getTreeResult = (p: getTreeResult) => SpirsApi.getTreeResult(p).then(r => r.body);

export type getTreeLive = Parameters<typeof SpirsApi.getTreeLive>[0]
export const getTreeLive = (p: getTreeLive) => SpirsApi.getTreeLive(p).then(r => r.body);

export const getRatingTree = (t : any) => SpirsApi.getRatingTree(t).then(r => r.body);

export const getPrematchTree = (time: string) => SpirsApi.getPrematchTree(time).then(r => r.body);

export const acceptWelcome = () => SpirsApi.acceptWelcome().then(r => r.body);

export type getMarketLimit = Parameters<typeof SpirsApi.getMarketLimit>[0];

export const getMarketLimit = (p: getMarketLimit) => SpirsApi.getMarketLimit(p).then(r => r.body);

export const getHomePage = () => SpirsApi.getHomePage().then(r => r.body);

export const getPage = (id: string) => SpirsApi.getPage({id}).then(r => r.body);

export const getTheme = () => SpirsApi.getTheme().then(r => r.body);

export const getRequiredAuth = () => SpirsApi.getRequiredAuth().then(r => r.body);

export const getHeader = () => SpirsApi.getHeader().then(r => r.body);

export const getLeftPanel = () => SpirsApi.getLeftPanel().then(r => r.body);

export const getRightPanel = () => SpirsApi.getRightPanel().then(r => r.body);

export const ping = () => SpirsApi.ping();


export type getFixturesSimple = Parameters<typeof SpirsApi.getFixturesSimple>[0]

export const getFixturesSimples = (p : getFixturesSimple) => SpirsApi.getFixturesSimpleList(p).then(r => r.body)


export const getAllFixturesTree = (time : string) => SpirsApi.getAllFixturesTree(time).then(r => r.body)


